const TraditionalChineseLanguageMap = {
  guidenotupdated:
    '此社群翻譯還未更新至最新版本的 Storybook。請透過英文版本的更變，協助我們更新此翻譯。',
  pullrequestmessage: '歡迎發送 Pull Request',
};

export default TraditionalChineseLanguageMap;
